function maybeElementId(id, suffix) {
  return id ? {
    id: suffix ? `${id}-${suffix}` : id
  } : {};
}
export default maybeElementId;